import {WlModal} from "./modal.component";
export * from './modal.component';

customElements.define("wl-modal", WlModal)